import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";

const API = "https://suadesarrollo.azurewebsites.net/api";

function FichaUpload({ recargar }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [instituciones, setInstituciones] = useState([]);

  const [institucionId, setInstitucionId] = useState("");
  const [ciclo, setCiclo] = useState("");
  const [nombre, setNombre] = useState("");
  const [ano, setAno] = useState("");
  const [archivo, setArchivo] = useState(null);

  const abrirModal = () => setIsOpen(true);
  const cerrarModal = () => setIsOpen(false);

  // Cargar instituciones
  const cargarInstituciones = async () => {
    try {
      const response = await fetch(`${API}/ObtenerInstituciones`);
      const data = await response.json();
      setInstituciones(data);
    } catch (error) {
      console.error("Error cargando instituciones", error);
    }
  };

  useEffect(() => {
    cargarInstituciones();
  }, []);

  const subirFicha = async (e) => {
    e.preventDefault();

    if (!institucionId || !ciclo || !nombre || !ano || !archivo) {
      alert("Todos los campos son obligatorios");
      return;
    }

    const formData = new FormData();

    // IMPORTANTE: enviar el ID de la institución
    formData.append("InstitucionId", institucionId);
    formData.append("Ciclo", ciclo);
    formData.append("Nombre", nombre);
    formData.append("Ano", ano);
    formData.append("file", archivo);

    try {
      const username = "BasicAuth@icontec.org";
      const password = "yQLzqmR7eZSuAmQZUqhY";

      const response = await fetch(`${API}/CargaFicha`, {
        method: "POST",
        headers: {
          Authorization: "Basic " + btoa(username + ":" + password),
        },
        body: formData,
      });

      const result = await response.json();

      console.log("Respuesta API:", result);
      console.log("InstitucionId enviado:", institucionId);

      if (!response.ok) {
        let mensaje = "";

        if (result.errors) {
          Object.keys(result.errors).forEach((campo) => {
            mensaje += result.errors[campo].join(", ") + "\n";
          });
        } else {
          mensaje = result.title || "Error al subir ficha";
        }

        alert(mensaje);
        return;
      }

      alert(result.mensaje || "Ficha cargada correctamente");

      cerrarModal();

      if (recargar) {
        recargar();
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error de conexión con el servidor");
    }
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={abrirModal}>
        Nueva Ficha
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={cerrarModal}
        contentLabel="Crear Ficha"
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Cargar Ficha Técnica
              </h6>
            </div>

            <div className="card-body">
              <form className="user" onSubmit={subirFicha}>
                {/* INSTITUCION */}
                <div className="form-group">
                  <select
                    className="form-control"
                    value={institucionId}
                    onChange={(e) => setInstitucionId(e.target.value)}
                    required
                  >
                    <option value="">Seleccione institución</option>

                    {instituciones.map((inst) => (
                      <option key={inst.id} value={inst.id}>
                        {inst.razon_Social}
                      </option>
                    ))}
                  </select>
                </div>

                {/* CICLO */}
                <div className="form-group">
                  <input
                    type="number"
                    className="form-control form-control-user"
                    placeholder="Ciclo"
                    value={ciclo}
                    onChange={(e) => setCiclo(e.target.value)}
                    required
                  />
                </div>

                {/* NOMBRE */}
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control form-control-user"
                    placeholder="Tipo de visita"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                  />
                </div>

                {/* AÑO */}
                <div className="form-group">
                  <input
                    type="number"
                    className="form-control form-control-user"
                    placeholder="Año"
                    value={ano}
                    onChange={(e) => setAno(e.target.value)}
                    required
                  />
                </div>

                {/* ARCHIVO */}
                <div className="form-group">
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => setArchivo(e.target.files[0])}
                    required
                  />
                </div>

                <hr />

                <button
                  type="submit"
                  className="btn btn-primary btn-user btn-block"
                >
                  Guardar
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default FichaUpload;
